import React, { Fragment, memo } from 'react'

import { HeaderSectionTransport } from '../../../transports/region-landing-page-transport'
import { EventPill, NavigationButton, NavigationButtonText } from './header-section-styles'
import { useTranslation } from '../../../hooks/locale'

type Navigation = HeaderSectionTransport['navigationSectionResponse']['navigation']

interface NavigationLinksProps {
    navigation: Navigation
    showVacationIdeasNavButton: boolean
    isMobile: boolean
    isTablet: boolean
    showNavigationLinks?: boolean
}

const NavigationLinks: React.FC<NavigationLinksProps> = ({
    navigation,
    showVacationIdeasNavButton,
    isMobile,
    isTablet,
    showNavigationLinks,
}) => {
    const { t } = useTranslation()
    const { vacationIdeasButton, offersButton, buyPropertyButton, helpButton, activitiesButton } = navigation

    if (isMobile || isTablet || !showNavigationLinks) {
        return null
    }

    return (
        <Fragment>
            {!!vacationIdeasButton?.url && showVacationIdeasNavButton && (
                <NavigationButton href={vacationIdeasButton.url} noCrawl={vacationIdeasButton.noCrawl}>
                    <NavigationButtonText>{vacationIdeasButton.text}</NavigationButtonText>
                </NavigationButton>
            )}
            {!!offersButton?.url && (
                <NavigationButton href={offersButton.url} noCrawl={offersButton.noCrawl}>
                    <NavigationButtonText>{offersButton.text}</NavigationButtonText>
                </NavigationButton>
            )}
            {!!buyPropertyButton?.url && (
                <NavigationButton href={buyPropertyButton.url} noCrawl={buyPropertyButton.noCrawl}>
                    <NavigationButtonText>{buyPropertyButton.text}</NavigationButtonText>
                </NavigationButton>
            )}
            {!!activitiesButton?.url && (
                <NavigationButton href={activitiesButton.url} noCrawl={activitiesButton.noCrawl}>
                    <NavigationButtonText>{activitiesButton.text}</NavigationButtonText>
                    <EventPill>{t('new')}</EventPill>
                </NavigationButton>
            )}
            {!!helpButton?.url && (
                <NavigationButton href={helpButton.url} noCrawl={helpButton.noCrawl}>
                    <NavigationButtonText>{helpButton.text}</NavigationButtonText>
                </NavigationButton>
            )}
        </Fragment>
    )
}

export default memo(NavigationLinks)
